import { render, staticRenderFns } from "./customer-tier-component.vue?vue&type=template&id=04913048&scoped=true"
import script from "./customer-tier-component.vue?vue&type=script&lang=js"
export * from "./customer-tier-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04913048",
  null
  
)

export default component.exports